function Consequence() {
  return (
    <div className="variant-consequence">
      <li className="bullet-item">
        The most severe consequence type according to the{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="http://www.ensembl.org/info/genome/variation/predicted_data.html"
        >
          Variant Effect Predictor
        </a>
      </li>
    </div>
  );
}

export default Consequence;
